import React, { Component } from 'react';
import {
    Label,
    Input,
    FormGroup,
    FormFeedback,
    Col
} from 'reactstrap';
import PropTypes from 'prop-types';
import './ConfirmPassword.css';
import { Utils } from './../../../utils/utils';
import _ from 'lodash';

class ConfirmPassword extends Component {
    render() {
        return (
            <div className="confirm-password-container">
                <FormGroup row>
                    <Label for="new-password" sm={3} >{_.get(this.props.translation, 'activation.enter_password_label')}*</Label>
                    <Col sm={9}>
                        <Input type="password" id="new-password"
                            value={this.props.password}
                            onChange={this.props.handleChange('password')}
                            required
                            placeholder={_.get(this.props.translation, 'activation.enter_password_input_placeholder')}
                            invalid={this.props.password !== "" ? !Utils.isValidPassword(this.props.password) : false}
                        />
                        <FormFeedback>{_.get(this.props.translation, 'activation.enter_password_error_alert')}</FormFeedback>
                    </Col>
                </FormGroup>
                <FormGroup row>
                    <Label for="new-password-confirm" sm={3} >{_.get(this.props.translation, 'activation.confirm_password_label')}*</Label>
                    <Col sm={9}>
                        <Input type="password"
                            id="new-password-confirm"
                            value={this.props.passwordConfirm}
                            onChange={this.props.handleChange('passwordConfirm')}
                            required
                            placeholder={_.get(this.props.translation, 'activation.confirm_password_input_placeholder')}
                            invalid={(this.props.password !== "" && this.props.passwordConfirm !== "") ? this.props.password !== this.props.passwordConfirm : false}
                        />
                        <FormFeedback>{_.get(this.props.translation, 'activation.confirm_password_error_alert')}</FormFeedback>
                    </Col>
                </FormGroup>
            </div>
        );
    }
}

ConfirmPassword.propTypes = {
    password: PropTypes.string.isRequired,
    passwordConfirm: PropTypes.string.isRequired,
    translation: PropTypes.object.isRequired,
    handleChange: PropTypes.func.isRequired
};

export default ConfirmPassword;



// WEBPACK FOOTER //
// ./src/components/accountManagement/confirmPassword/ConfirmPassword.js